export class DefaultEnvironment {
    dev?= false
    mode?: 'dev' | 'test' | 'prod'
    production?= false
    apiUrl: string
    socketUrl: string

  systemState: 'Seattle' | 'California'
  systemSeattleUrl: string;
  systemCaliforniaUrl: string;
  systemCartTvUrl: string;


  // CART TV
  defaultBufferCountForCarts? = 7;
  defaultBufferResetTime? = 1000;
  defaultCartGreenStyleDissapearTime ?= 10000
  defaultCartGreenReShowTime ?= 200;
};
